const Utils = require('./CH2Utilities');

class CH2Intructions {
    constructor() {
        this.instructionContainer = null;
        this.window = null;
        this.navigator = null;
        this.utils = new Utils();
    }

    /**
     * It creates the instruction interface
     * @param {container} container - The HTML containing the Instruction Interface.
     * @param {window} _window - Window client.
     * @param {navigator} _navigator - Navigator client.
     * @param {animationType} _businessUnitType - The type of animation to be displayed.
     */
    createInstructionInterface(container, _window, _navigator, _businessUnitType = 'default') {
        if (!document.getElementById('ch2_guided-instructions-container')) {
            this.window = _window;
            this.navigator = _navigator;
            // Create Container
            this.instructionContainer = document.createElement('div');
            this.instructionContainer.id = 'ch2_guided-instructions-container';
            container.appendChild(this.instructionContainer);
            // Close Button
            const buttonClose = document.createElement('button');
            buttonClose.id = 'ch2_guided-instructions-close';
            buttonClose.innerHTML = `<svg role="img" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"> <path d="m14 14.7-7-7-7 7-.7-.7 7-7-7-7 .7-.7 7 7 7-7 .7.7-7 7 7 7z" fill="currentColor" /> <path d="M0 0l14 14m0-14L0 14" stroke="currentColor" fill="none" stroke-linecap="square" /></svg>`;
            buttonClose.onclick = function () {
                this.closeInstructionInterface();
            }.bind(this);
            this.instructionContainer.appendChild(buttonClose);

            let animationName;

            switch (_businessUnitType) {
            case 'default':
                animationName = '3dIcon_default';
                break;
            case 'wannaVTO':
                animationName = '3dIcon_Wanna';
                this.addCutstomText();
                break;
            default:
                animationName = '3dIcon_default';
            }

            // Animated Icon
            if (this.utils.isMobile(this.navigator)) {
                const mobileAnimatedIcon = document.createElement('div');
                mobileAnimatedIcon.id = 'ch2_mobile-icon';
                mobileAnimatedIcon.className = `ch2_hide-for-large${animationName === '3dIcon_Wanna' ? ' ch2_wannaVTO' : ''}`;
                this.instructionContainer.appendChild(mobileAnimatedIcon);

                const animationLottie = {
                    name: 'mobile3dInfoAnimation',
                    container: document.getElementById('ch2_mobile-icon'),
                    renderer: 'svg',
                    loop: true,
                    path: `${window.staticURL}images/animatedIcons/mobile${animationName}.json`,
                };
                window.lottie.loadAnimation(animationLottie);

                window.lottie.play('mobile3dInfoAnimation');
            } else {
                const desktopAnimatedIcon = document.createElement('div');
                desktopAnimatedIcon.id = 'ch2_desktop-icon';
                desktopAnimatedIcon.className = `ch2_hide-for-large${animationName === '3dIcon_Wanna' ? ' ch2_wannaVTO' : ''}`;
                this.instructionContainer.appendChild(desktopAnimatedIcon);

                const animationLottie = {
                    name: 'desktop3dInfoAnimation',
                    container: document.getElementById('ch2_desktop-icon'),
                    renderer: 'svg',
                    loop: true,
                    path: `${window.staticURL}images/animatedIcons/desktop${animationName}.json`,
                };
                window.lottie.loadAnimation(animationLottie);

                window.lottie.play('desktop3dInfoAnimation');
            }
        }
    }

    closeInstructionInterface() {
        if (this.utils.isMobile(this.navigator)) {
            window.lottie.stop('mobile3dInfoAnimation');
        } else {
            window.lottie.stop('desktop3dInfoAnimation');
        }
        this.instructionContainer.remove();
        this.instructionContainer = null;
    }

    addCutstomText() {
        const customTextWrapper = document.createElement('div');
        customTextWrapper.id = 'ch2_guided-instructions-custom-text-wrapper';

        const customText = document.createElement('div');
        customText.id = 'ch2_guided-instructions-custom-text';
        customText.innerHTML = this.htmlDecode(this.window.Resource.msg.labelWatchIntructions);

        customTextWrapper.appendChild(customText);
        this.instructionContainer.appendChild(customTextWrapper);
    }

    htmlDecode = (input) => {
        const doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.textContent;
    }
}

module.exports = CH2Intructions;
